export function initHeaderNav() {
	window.addEventListener('click', toggleNav);
}

export function initMakeNeaderNavTransparent() {
	let els = document.querySelectorAll('.make-header-nav-transparent');
	if(els.length === 0) return;

	window['MakeHeaderNavTransparentEls'] = els;
	checkMakeHeaderNavTransparent();
	document.addEventListener('scroll', checkMakeHeaderNavTransparent);
}

function toggleNav(e) {
    if(!e.target.dataset.toggleNav) {
        return;
    }

    const nav = document.querySelector('[data-main-nav]');
    nav?.classList.toggle('show-nav');
		const nav_buttons = document.querySelector('[data-nav-buttons]');
    nav_buttons?.classList.toggle('show-nav');
		document.body.classList.toggle('nav-open');
		e.target.classList.toggle('nav-open');

    if(nav?.classList.contains('show-nav')) {
        document.documentElement.classList.add('scroll-locked');
    }
    else {
        document.documentElement.classList.remove('scroll-locked');
    }

}

function checkMakeHeaderNavTransparent() {
	let header = document.querySelector('header');
	let scrollY = header.offsetHeight + window.scrollY;
	let nopeCount = 0;

	for(let x = 0; window['MakeHeaderNavTransparentEls'][x]; x++) {
		let el = window['MakeHeaderNavTransparentEls'][x];
		let elTop = el.getBoundingClientRect().top + window.scrollY;

		if((scrollY >= elTop) && (window.scrollY <= elTop + el.offsetHeight)) {
			if(!window['HeaderNavTransparent']) {
				document.body.classList.add('header-nav-transparent');
				window['HeaderNavTransparent'] = true;
			}
			return; // we do not to check more
		}
		else {
			if(window['HeaderNavTransparent']) {
				nopeCount++;
			}
		}
	}

	if(nopeCount == window['MakeHeaderNavTransparentEls'].length) {
		document.body.classList.remove('header-nav-transparent');
		window['HeaderNavTransparent'] = false;
	}

}